import * as React from 'react';
import {Box, Typography} from '@mui/material';

// The shape of the plain, public pages (privacy policy and the like): a title, a date, and sections of ordinary text.
export function LegalPage({title, updated, children}: { title: string, updated: string, children: React.ReactNode }) {
    return (
        <Box component="article" sx={{maxWidth: 760, mx: 'auto', py: 2, '& h2': {mt: 4, mb: 1}, '& p, & li': {lineHeight: 1.7}, '& ul': {pl: 3}}}>
            <Typography variant="h4" component="h1">{title}</Typography>
            <Typography variant="body2" color="text.secondary" sx={{mt: 0.5}}>Last updated: {updated}</Typography>
            {children}
        </Box>
    );
}

export const Section = ({title, children}: { title: string, children: React.ReactNode }) => (
    <section>
        <Typography variant="h6" component="h2">{title}</Typography>
        {children}
    </section>
);
